<template>
    <q-page class="flex flex-center">
        <transition-group appear :duration="{ enter: 1500, leave: 800 }" enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" class="group">
            <q-card key="brand" inline style="width: 500px;background-color: rgba(241, 237, 244, 0.2);border-radius:25px;border:2px solid #b2abb0;filter: brightness(90%) contrast(90%) grayscale(0%)" class="flex flex-center q-pa-md">
               <q-btn round flat color="primary" icon="fas fa-chevron-left" @click="$router.go(-1)"/>
                <q-card-section>
                    
                    <div class="text-h5 text-center text-white text-bold">Forgot User ID/ Password</div>
                </q-card-section>
                <q-form @submit="triggerFunctions" class="q-gutter-md">
                <q-card-section>
                    
                    <div class="row">
                        <div class="col-4">
                             <div class="q-caption text-white ">Please help, I have forgotten my</div>
                                
                        </div>
                        <div class="col-6">
                            <q-option-group
                            class=" text-white"
                            :options="StoreStateAOD.ResetOptions"
                            label="Notifications"
                            type="radio"
                            v-model="StoreStateAOD.ResetGroup"
                            />
                        </div>
                    </div>
                    
                <q-form @submit="trigerUserVerfication" class="q-gutter-md">
                    <div class="row">
                        <div class="col-4  column self-center">
                            <div class="q-caption text-white ">Please enter your NRIC No.</div> 
                        </div>
                        <div class="col-6">
                            <q-input dark standout rounded style="margin-left:10px;"  key="text" v-model="StoreStateAOD.userID" mask="######-##-####" hint="123456-00-6789 or 1234567"  :before="[{icon: 'fas fa-user-circle', handler () {}}]" :rules="[val => !!val || 'NRIC No. / Passport No is required']">
                            </q-input>
                        </div>

                         <div class="col-2 column items-end">
                            <q-btn round color="primary" icon="phone" type="submit" >
                                <q-tooltip>
                                    Click to request TAC
                                </q-tooltip>
                            </q-btn>
                        </div>
                    </div>
                    
                </q-form>
                    <div class="row" v-if="StoreStateAOD.requestedTac==true">
                        <div class="col-4 column self-center">
                            <div class="q-caption text-white ">TAC Code</div> 
                        </div>
                        <div class="col-6 tacCode">
                            <q-input  dark standout rounded  type="password" v-model="StoreStateAD.TAC_code" label="TAC"   :before="[{ handler () {}}]" :rules="[val => !!val || 'TAC is required']">
                            </q-input>
                        </div>
                    </div>
                </q-card-section>
                   <q-card-section>
                        <div class="text-subtitle2">Note: Please ensure you have pre-registered your mobile number with Affin Hwang Asset Management before your request for verification code.</div>
                    </q-card-section>
                     <q-card-section v-if="StoreStateAOD.requestedTac==true">
                           <div class="row">
                            <div class="col column items-end">
                                <q-btn style="margin-left:10px;" label="Next"  type="submit" color="blue"></q-btn>
                            </div>
                            <div class="col">
                                <q-btn style="margin-left:10px;"   label="Cancel" @click="triggerReroute" text-color="black" color="white"></q-btn>
                            </div>
                        </div>
                      </q-card-section>
                    </q-form>
            </q-card>
        </transition-group>
    <q-dialog v-model="StoreStateAOD.ResetPasswordUsername" persistent transition-show="scale" transition-hide="scale">
      <q-card>
        <q-card-section>
          <div class="text-h6">You may Reset Username/Password here</div>
        </q-card-section>
        <q-card-section>
            <ResetUsernamePassword/>
        </q-card-section>
      </q-card>
    </q-dialog>


    </q-page>
</template>
<script>
//import "@/assets/css/iAccessTheme.css";
import { mapState, mapActions } from "vuex";
import store from '../store';
import ResetUsernamePassword from '@/components/ResetUsernamePassword.vue'
export default {
    components:{
        ResetUsernamePassword
    },
  data() {
    return {
        StoreStateAD : store.state.AD, 
        StoreStateAOD : store.state.AOD, 
        tempMobileNo:'',
    };
  },
  mounted(){
      
        store.commit("ResetAODetails");
        store.commit("ResetState_AD");
  },
    methods:{
         ...mapActions([
            "GetInvestorMobileCif",
            "RequestTAC",
            "TACVerification",
            "retrieveIAccessUsername"
        ]),

        triggerReroute:function(){
             this.$router.push({ name: "AHAM Login"});
        },
        trigerUserVerfication:function(){

            this.$q.loading.show({
             spinnerSize : 50
            })

            var tempID = this.StoreStateAOD.userID.replace('-','')
            tempID = tempID.replace('-','')
             this.GetInvestorMobileCif({
                  UserId:tempID.trim()
             }).then(res =>{
                 if((res !='false')|| (res != false)){
                      this.$q.dialog({
                            title : 'Message',
                            message : 'A TAC has been sent to your mobile no ' + this.tempMobileNo
                        })
                                        /* this.formatMobileNo(res);
                         this.RequestTAC({
                            //res
                            CustomerTelMobile :'0149638728' ,
                            Purpose : 'I-Invest - Account Verification',
                            CustomerId : this.StoreStateAOD.userID,
                            RIDType : ''
                        })
                        .then(res=>{
                            this.$q.loading.hide()
                            if(res===true){
                                this.$q.dialog({
                                    title : 'Message',
                                    message : 'A TAC has been sent to your mobile no ' + this.tempMobileNo 
                                })
                                
                                this.StoreStateAOD.requestedTac= true;
                            }else{
                                  this.$q.dialog({
                                    title : 'Message',
                                    message : 'Something went wrong, please restart the transaction'
                                })
                            }
                        }) */
                 }else{
                    this.$q.loading.hide()
                    this.$q.dialog({
                        title : 'Message',
                        message : 'Something went wrong, please restart the transaction'
                    })
                 }
             })
        },
        triggerFunctions:function(){
            this.$q.loading.show({
                spinnerSize : 50
            })

            this.TACVerification({
                 CustomerId : this.StoreStateAOD.userID,
                 TAC: this.StoreStateAD.TAC_code,
                 Purpose: 'EMIS - Account Verification'
             }).then(res=>{
                if(res===false){
                    
                    this.$q.loading.hide()
                    this.$q.dialog({
                        title : 'Message',
                        message : 'Error. Please retry.'  
                    })
                }else if( res == true){
                    if(this.StoreStateAOD.ResetGroup == 'useridOnly'){
                        this.retrieveIAccessUsername({
                            appid : this.StoreStateAOD.userID
                        })
                        .then(res=>{
                            this.$q.loading.hide()
                            if(res===false){
                                this.$q.dialog({
                                    title : 'Message',
                                    message : res  
                                })
                            }else{
                                this.$q.dialog({
                                    title : 'Hi There..',
                                    message : 'Your username to login is : ' + res  
                                }).onOk(() => {
                                    
                                     this.$router.push({ name: "AHAM Login"});
                                })
                            }
                        })
                    }else if(this.StoreStateAOD.ResetGroup == 'useridAndPassword'){
                        this.$q.loading.hide()
                         this.retrieveIAccessUsername({
                            appid : this.StoreStateAOD.userID
                        })
                        .then(res=>{
                            this.$q.loading.hide()
                            if(res===false){
                                this.$q.dialog({
                                    title : 'Message',
                                    message : res  
                                })
                            }else{
                                
                                this.$q.loading.hide()
                                this.StoreStateAOD.ResetPasswordUsername= true;
                            }
                        })
                    }                   
                }
            })
        },
        formatMobileNo:function(obj) {

        var mobileNo = obj       
        this.tempMobileNo =  '01x- xxxx ' + mobileNo.slice(-4) ;
      }
    }
}
</script>
<style>


</style>